import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore'; // updateDoc yerine setDoc kanka
import { FaCalendarAlt, FaChartLine, FaSave } from 'react-icons/fa';
import './MezatManager.css';
import { db } from '../firebase/firebase-config';

const MezatManager = () => {
  const [settings, setSettings] = useState({
    pazartesi: '21:00',
    cuma: '22:00',
    pazar: '21:00',
    eserSayisi: '150+',
    koleksiyonerSayisi: '10K+',
    mezatLink: 'https://www.tiktok.com/@tesbihcimen.collection?lang=tr-TR'
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "siteSettings", "general");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSettings(docSnap.data());
        }
      } catch (err) {
        console.error("Veri çekilirken hata:", err);
      }
    };
    fetchSettings();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const docRef = doc(db, "siteSettings", "general");
      
      // Kanka burası sihirli dokunuş: setDoc + merge: true
      // Doküman yoksa oluşturur, varsa sadece değişen alanları günceller.
      await setDoc(docRef, settings, { merge: true });
      
      alert("Mezat programı ve sayılar başarıyla güncellendi kanka!");
    } catch (err) {
      console.error("Güncelleme hatası:", err);
      alert("Hata çıktı kral: " + err.message);
    }
    setLoading(false);
  };

  return (
    <div className="mezat-manager-wrapper">
      <form onSubmit={handleUpdate} className="mezat-form">
        
        <section className="mezat-section">
          <h3><FaCalendarAlt /> Haftalık Mezat Saatleri</h3>
          <div className="m-input-grid">
            <div className="m-input-group">
              <label>Pazartesi - Çarşamba</label>
              <input 
                type="text" 
                value={settings.pazartesi} 
                onChange={e => setSettings({...settings, pazartesi: e.target.value})} 
                placeholder="Örn: 21:00"
              />
            </div>
            <div className="m-input-group">
              <label>Cuma (Büyük Mezat)</label>
              <input 
                type="text" 
                value={settings.cuma} 
                onChange={e => setSettings({...settings, cuma: e.target.value})} 
                placeholder="Örn: 22:00"
              />
            </div>
            <div className="m-input-group">
              <label>Pazar</label>
              <input 
                type="text" 
                value={settings.pazar} 
                onChange={e => setSettings({...settings, pazar: e.target.value})} 
                placeholder="Örn: 21:00"
              />
            </div>
          </div>
        </section>

        <section className="mezat-section">
          <h3><FaChartLine /> Canlı İstatistikler</h3>
          <div className="m-input-grid">
            <div className="m-input-group">
              <label>Nadir Eser Sayısı</label>
              <input 
                type="text" 
                value={settings.eserSayisi} 
                onChange={e => setSettings({...settings, eserSayisi: e.target.value})} 
                placeholder="Örn: 150+"
              />
            </div>
            <div className="m-input-group">
              <label>Koleksiyoner Sayısı</label>
              <input 
                type="text" 
                value={settings.koleksiyonerSayisi} 
                onChange={e => setSettings({...settings, koleksiyonerSayisi: e.target.value})} 
                placeholder="Örn: 10K+"
              />
            </div>
            <div className="m-input-group">
              <label>Mezat Linki (TikTok)</label>
              <input 
                type="text" 
                value={settings.mezatLink} 
                onChange={e => setSettings({...settings, mezatLink: e.target.value})} 
                placeholder="https://..."
              />
            </div>
          </div>
        </section>

        <button type="submit" className="m-save-btn" disabled={loading}>
          {loading ? "KRİPTOLANIYOR..." : <><FaSave /> DEĞİŞİKLİKLERİ KAYDET</>}
        </button>
      </form>
    </div>
  );
};

export default MezatManager;